import { render } from "./SideBarNavItem.vue?vue&type=template&id=129e3586&scoped=true&ts=true"
import script from "./SideBarNavItem.vue?vue&type=script&lang=ts"
export * from "./SideBarNavItem.vue?vue&type=script&lang=ts"

import "./SideBarNavItem.vue?vue&type=style&index=0&id=129e3586&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129e3586"]])

export default __exports__